import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function cloneRows(rows) {
  return (rows || []).map((row) => (Array.isArray(row) ? [...row] : row));
}

function toSheetFromJson(data) {
  const rows = Array.isArray(data) ? data : [];
  const headers = [];

  rows.forEach((item) => {
    if (!item || typeof item !== 'object') {
      return;
    }
    Object.keys(item).forEach((key) => {
      if (!headers.includes(key)) {
        headers.push(key);
      }
    });
  });

  const body = rows.map((item) => headers.map((key) => (item && key in item ? item[key] : '')));
  return { __rows: [headers, ...body] };
}

function toSheetFromAoa(data) {
  return { __rows: cloneRows(Array.isArray(data) ? data : []) };
}

function ensureSheetRows(sheet) {
  if (!sheet || !Array.isArray(sheet.__rows)) {
    return [];
  }
  return sheet.__rows;
}

function toWorkbook(wb) {
  const workbook = new ExcelJS.Workbook();
  const sheets = wb && Array.isArray(wb.__sheets) ? wb.__sheets : [];

  sheets.forEach((sheet, index) => {
    const sheetName = sheet?.name || `Sheet${index + 1}`;
    const worksheet = workbook.addWorksheet(sheetName);
    ensureSheetRows(sheet?.data).forEach((row) => {
      worksheet.addRow(Array.isArray(row) ? row : [row]);
    });
  });

  return workbook;
}

export const utils = {
  json_to_sheet(data) {
    return toSheetFromJson(data);
  },
  aoa_to_sheet(data) {
    return toSheetFromAoa(data);
  },
  sheet_add_aoa(sheet, aoa, options = {}) {
    const currentRows = ensureSheetRows(sheet);
    const newRows = cloneRows(Array.isArray(aoa) ? aoa : []);
    if (options.origin === 0) {
      sheet.__rows = [...newRows, ...currentRows];
      return sheet;
    }
    sheet.__rows = [...currentRows, ...newRows];
    return sheet;
  },
  book_new() {
    return { __sheets: [] };
  },
  book_append_sheet(workbook, worksheet, name = 'Sheet1') {
    if (!workbook.__sheets) {
      workbook.__sheets = [];
    }
    workbook.__sheets.push({ name, data: worksheet });
    return workbook;
  },
};

export async function write(workbook, _options = {}) {
  const excelWorkbook = toWorkbook(workbook);
  const buffer = await excelWorkbook.xlsx.writeBuffer();
  return buffer;
}

export async function writeFile(workbook, filename = 'reporte.xlsx') {
  const buffer = await write(workbook, { type: 'array' });
  const blob = new Blob(
    [buffer],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  );
  saveAs(blob, filename);
}

const XLSX = {
  utils,
  write,
  writeFile,
};

export default XLSX;
